module.exports = __webpack_public_path__ + "img/backyard-alt-wide.42ca6217.jpg";